export const FiltersLabel = {
  country: 'Country',
  region: 'Region',
  colonial_heritage: 'Colonial heritage',
  constitutional_event: 'Constitutional Event',
  type_of_transition: 'Type of transition',
  level_of_violence: 'Level of violence',
  peace_keeping_force: 'Peace-keeping force',
  change_to_state_structure: 'Change to state structure',
  constitution_making_body: 'Constitution-making body',
  referendum_held: 'Referendum held',
  interim_constitution: 'Interim constitution',
  direct_international_support: 'Direct international support',
};

export const FiltersTagLabel = {
  topics: 'Topic: ',
  country: 'Country: ',
  region: 'Region: ',
  colonial_heritage: 'Colonial heritage: ',
  constitutional_event: 'Constitutional Event: ',
  type_of_transition: 'Type of transition: ',
  level_of_violence: 'Level of violence: ',
  peace_keeping_force: 'Peace-keeping force: ',
  change_to_state_structure: 'Change to state structure: ',
  constitution_making_body: 'Constitution-making body: ',
  referendum_held: 'Referendum held: ',
  interim_constitution: 'Interim constitution: ',
  direct_international_support: 'Direct international support: ',
};

export const FiltersTooltip = {
  country: 'Country',
  region: 'Geographic region.',
  colonial_heritage: 'The colonial heritage of the country in which the process took place.',
  constitutional_event: 'Constitutional Event',
  type_of_transition: 'The type of conflict that led to the process.',
  level_of_violence: 'The level of violence during the process.  Minor armed conflict refers to 25-999 battle-related deaths per year.  Major armed conflict refers to over 1000 battle-related deaths per year.',
  peace_keeping_force: 'Whether there was a peacekeeping force throughout the process in the country in which the process took place.',
  change_to_state_structure: 'The effect of the process on the territorial structure of the state.',
  constitution_making_body: 'The type of body that had final responsibility for the draft prior to ratification.',
  referendum_held: 'Whether a referendum was held to ratify the change to the constitution.',
  interim_constitution: 'Whether an interim constitution was enacted during the process.',
  direct_international_support: 'Whether international actors provided any type of broad-based support vis-à-vis the associated political settlement process.',
};